import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';

const useTrackDiscardClicked = () => {
  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(
    ({ contentId, isEdited }: { contentId: string; isEdited: boolean }) => {
      const trackProductAnalytics = trackAnalytics(productEvents);

      trackProductAnalytics('Results Discarded', {
        'Is Edited': isEdited,
        'Content ID': contentId,
      });
    },
    [productEvents],
  );

  return trackCallback;
};

export default useTrackDiscardClicked;
